export default __webpack_public_path__ + "static/media/pfp.dc4c5472.jpg";